// Client resolvers for Apollo
import gql from 'graphql-tag'
import { QueryTopicViewCard, QuerySsrsTreeOpen, QueryProfileProccessed } from '~/queries/client.gql'

export default {
  Mutation: {
    updateTopicViewCard (_root, { topicViewCard }, { cache }) {
      cache.writeQuery({
        query: QueryTopicViewCard,
        data: {
          topicViewCard: topicViewCard
        }
      })
      return topicViewCard
    },

    updateSsrsTreeOpen (_root, { ssrsTreeOpen }, { cache }) {
      cache.writeQuery({
        query: QuerySsrsTreeOpen,
        data: {
          ssrsTreeOpen
        }
      })
      return ssrsTreeOpen
    },

    updateProfileProccessed (_root, { profileProccessed }, { cache }) {
      cache.writeQuery({
        query: QueryProfileProccessed,
        data: {
          profileProccessed: profileProccessed
        }
      })
      return profileProccessed
    },

    updateDocumentRetrievalDeficiency (_root, { id, deficiencyAnswers }, { cache }) {
      cache.writeFragment({
        id: `DocumentRetrievalDeficiency:${id}`,
        fragment: gql`
          fragment DeficienciesAnswersInfo on DocumentRetrievalDeficiency {
            deficiencyAnswers @client
          }
        `,
        data: {
          __typename: 'DocumentRetrievalDeficiency',
          deficiencyAnswers: { ...deficiencyAnswers, __typename: 'DeficienciesAnswersDeficiencies', time: Date.now() }
        }
      })
    }
  },
  DocumentRetrievalDeficiency: {
    deficiencyAnswers () {
      return {}
    }
  }
}
